/* eslint-disable import/no-cycle */
import _ from 'lodash';
import { setCustomer, clear } from './actions';
import { ROOT_SLICE } from './constants';
import { initialState } from './initialState';
import {
	selectThisSlice,
} from './selectors';

// ************
// PARTS
// ************
const reducerParts = {
	[clear]: state => {
		return {
			...state,
			[ROOT_SLICE]: _.cloneDeep(initialState)
		};
	},
  
  [setCustomer]: (state, { payload: { customer } }) => {
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        customer
			}
		};
  },
};

export default reducerParts;
